import { FormEvent, useState } from "react";
import { LogIn } from "lucide-react";
import { Brand } from "../components/Brand";
import { isSupabaseConfigured, supabase } from "../lib/supabase";

export function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setBusy(true); setMessage("");
    try {
      const { error } = await supabase.auth.signInWithPassword({ email, password });
      if (error) setMessage(error.message === "Invalid login credentials" ? "Email hoặc mật khẩu không đúng." : error.message);
    } catch (cause) {
      setMessage(cause instanceof Error ? cause.message : "Không thể kết nối Supabase.");
    } finally { setBusy(false); }
  };
  return (
    <div className="login-page">
      <section className="login-card card">
        <Brand />
        <h1>Đăng nhập</h1>
        <p className="muted">Mở bộ từ và tiến độ học của bạn.</p>
        {!isSupabaseConfigured ? <div className="feedback error">Chưa cấu hình Supabase. Hãy tạo file <code>.env.local</code> từ <code>.env.example</code>.</div> : null}
        {message ? <div className="feedback error">{message}</div> : null}
        <form onSubmit={submit}>
          <label>Email<input type="email" autoComplete="username" value={email} onChange={(event) => setEmail(event.target.value)} required autoFocus /></label>
          <label>Mật khẩu<input type="password" autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} required /></label>
          <button className="primary" type="submit" disabled={busy || !isSupabaseConfigured}><LogIn size={18} />{busy ? "Đang mở..." : "Mở KungKung"}</button>
        </form>
      </section>
    </div>
  );
}
